<template>
  <drag-dialog
    :visible.sync="visible"
    :title="`委托单流程详情【${detailData.reportCode || ''}】`"
    width="1000px"
    height="95vh"
    :before-close="() => $emit('update:visible', false)"
    @close="$dialogFormReset()"
  >
    <div v-loading="detailLoading">
      <el-steps :active="flowStep" align-center style="margin-bottom: 20px">
        <el-step title="待接样"></el-step>
        <el-step title="任务待分配"></el-step>
        <el-step title="实验中"></el-step>
        <el-step title="原始记录、报告审核中"></el-step>
        <el-step title="报告批准中"></el-step>
        <el-step title="报告&样品领取中"></el-step>
        <el-step title="已完成"></el-step>
      </el-steps>

      <el-collapse v-model="activeCollapse">
        <el-collapse-item name="1">
          <div slot="title" class="collapse-title flx-justify-between">
            <div>记录编号：{{ entrustSKH }}</div>
            <div>{{ isCollapse ? '展开' : '收起' }}</div>
          </div>

          <EntrustTable :detailData="detailData" />
        </el-collapse-item>
      </el-collapse>

      <div class="other-info">
        <div>结算类型：{{ detailData.stmtWay == 0 ? '合同' : detailData.stmtWay == 1 ? '现付' : '统一开票' }}</div>
        <div>开票信息：{{ detailData.ivTitle }}</div>
        <div>是否邮寄：{{ detailData.isIvDdeliver == 1 ? '是' : '否' }}</div>
        <div>特殊说明(内部)：{{ detailData.noteInner || '无' }}</div>
        <div>样品状态描述：{{ detailData.scac }}</div>
        <div class="sign-info">
          <div>客户确认签名：</div>
          <img class="sign-image" v-if="detailData.clientSign" :src="$imgUrl + detailData.clientSign" />
        </div>
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <!-- TODO: 下载委托协议书 -->
      <el-button type="primary" @click="handleDownloadEntrust">下载委托协议书</el-button>

      <el-button @click="$emit('update:visible', false)">关 闭</el-button>
    </div>
  </drag-dialog>
</template>

<script>
import EntrustTable from '@/components/BusinessComponents/EntrustTable';

import { getDictData } from '@/api/system';
import { getFlowInfo, downloadEntrustmentExcel } from '@/api/flow';

export default {
  components: { EntrustTable },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    activeId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      entrustSKH: '',
      flowStep: 0,
      activeCollapse: [],
      detailLoading: false,
      detailData: {}
    };
  },
  computed: {
    isCollapse({ activeCollapse }) {
      return activeCollapse.length == 0;
    }
  },
  watch: {
    visible(val) {
      if (val && this.activeId) this.getDetailData();
    }
  },
  methods: {
    async getDetailData() {
      this.detailLoading = true;

      try {
        const { data } = await getFlowInfo({ entrustmentId: this.activeId });
        this.detailData = data.entrustment ?? {};
        this.detailData.sampleInfoList = data.sampleInfoList ?? [];
        const state = data?.flow?.state ?? 0;
        switch (state) {
          case 2:
            this.flowStep = 0;
            break;
          case 3:
            this.flowStep = 1;
            break;
          case -8:
          case -9:
          case 4:
            this.flowStep = 2;
            break;
          case 7:
            this.flowStep = 3;
            break;
          case 8:
            this.flowStep = 4;
            break;
          case 9:
            this.flowStep = 5;
            break;
          case 10:
            this.flowStep = 7;
            break;
        }

        if (this.detailData.reportCode.startsWith('SA')) {
          if (this.detailData.etmtType == 'etmt_type_unvs') {
            const data = await getDictData({ code: 'SKH_entrust_01' });
            this.entrustSKH = data?.[0]?.value ?? '';
          } else {
            const data = await getDictData({ code: 'SKH_entrust_02' });
            this.entrustSKH = data?.[0]?.value ?? '';
          }
        } else {
          const data = await getDictData({ code: 'SKH_entrust' });
          this.entrustSKH = data?.[0]?.value ?? '';
        }
      } finally {
        this.detailLoading = false;
      }
    },
    async handleDownloadEntrust() {
      const res = await downloadEntrustmentExcel({
        entrustmentId: this.activeId
      });
      // 解析文件名
      let filename = '委托协议书.xlsx';
      const contentDisposition = res.headers['content-disposition'];
      if (contentDisposition) {
        const matches = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        if (matches && matches[1]) {
          filename = matches[1].replace(/['"]/g, '');
          filename = decodeURIComponent(filename);
        }
      }

      // 创建 Blob URL 并触发下载
      const blob = new Blob([res.data], { type: 'application/octet-stream' }); // 显式指定类型
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      URL.revokeObjectURL(link.href);
      this.$message.success('下载成功');
    }
  },
  created() {},
  mounted() {}
};
</script>

<style lang="scss" scoped>
.record-code {
  font-size: 14px;
  color: #101010;
  margin-bottom: 14px;
}

::v-deep .el-step__title {
  line-height: 1.5em;
  padding-top: 4px;
}

.collapse-title {
  width: 100%;
}

.other-info {
  > div {
    display: flex;
    align-items: flex-start;
    margin: 5px 0;
    font-size: 14px;
    line-height: 1.5em;
    color: #101010;
  }
  .sign-image {
    width: 140px;
    height: auto;
  }
}

::v-deep .el-table__header {
  .el-table__cell {
    background: #f2f2f2;
    color: #606266;
  }
}
</style>
